<template>
  <div class="about">
    <h1>Sync Histories</h1>

    <section v-if="multilocation && !loading">
      <v-data-table
          :headers="headers"
          :items="orders"
          hide-actions
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.order_name }}</td>
                  <v-data-table
                    :headers="detailHeaders"
                    :items="props.item.auto_group_sync_history"
                    hide-actions
                    class="elevation-1"
                  >
                    <template slot="items" slot-scope="props">
                      <td>{{ props.item.status }}</td>
                      <td>{{ props.item.shopify_product_title }}</td>
                      <td>{{ props.item.shopify_variant_title }}</td>
                      <td>{{ props.item.shopify_variant_title }}</td>
                    </template>
                  </v-data-table>
          </template>
        </v-data-table>
    </section>

  </div>
</template>

<script>
import axios from 'axios';

export default {
  computed: {
    count () {
      return this.$store.state.count
    }
  },
  created: function () {
  },
  data () {
    return {
      info: null,
      loading: true,
      orders: null,
      errored: false,
      multilocation: false,
      headers: [
        {
          text: 'Order No',
          align: 'left',
          sortable: false,
          value: 'name'
        },
      ],
      detailHeaders: [
        {
          text: 'Status',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Title',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Option',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        {
          text: 'Quantity',
          align: 'left',
          sortable: false,
          value: 'name'
        },
      ],
    }
  },
  filters: {
    currencydecimal (value) {
      return value.toFixed(2)
    }
  },
  mounted () {
    axios.defaults.headers.common['Authorization'] =  'Bearer ' + this.$store.getters.code

    this.checkMultiLocationStatus()
    this.getOrders()


  },

  methods : {

    getOrders () {
      let url = 'https://' + this.$store.getters.engine + '/api/v2/orders'

      axios
        .get(url)
        .then(response => {
          this.orders = response.data
          this.loading = false
        })
        .catch(error => {
        })
        .finally(() => {
        })
    },
    checkMultiLocationStatus () {
      let url = 'https://' + this.$store.getters.engine + '/api/location/status'

      axios
        .get(url)
        .then(response => {
          this.multilocation = (response.data.multilocation === 'enabled')
        })
        .catch(error => {
        })
        .finally(() => {
        })
    },

  }

}
</script>
